import CustomQuery from './CustomQueryView';

export default angular
  .module('components.tb.customQuery', ['react'])
  .directive('tbCustomQuery', (reactDirective, $state, $http, RelationsService) => reactDirective(CustomQuery, ['result'], {}, { $state, $http, RelationsService }))